export const COOKIE_NAME_SW_CONTEXT_TOKEN = 'sw-context-token';
export const COOKIE_NAME_OAUTH2_ACCESS_TOKEN = 'oauth2_access_token';
export const COOKIE_NAME_OAUTH2_REFRESH_TOKEN = 'oauth2_refresh_token';
export const COOKIE_NAME_OAUTH2_ID_TOKEN = 'oauth2_id_token';
export const COOKIE_NAME_OAUTH2_REDIRECT_TO = 'oauth2_redirect_to';
export const COOKIE_NAME_OAUTH2_STATE = 'oauth2_state';
export const COOKIE_NAME_OAUTH2_CODE_VERIFIER = 'oauth2_code_verifier';
/** Marks an OAuth login started from the Storyblok Visual Editor popup flow. */
export const COOKIE_NAME_OAUTH2_POPUP = 'oauth2_popup';

/** Controls whether our Storyblok Proxy returns draft content or only published content. Set the cookie value to `true` to enable draft mode. */
export const COOKIE_NAME_DRAFT_MODE = 'draft_mode';

/** Stores the access token of the current user for communicating with Docebo */
export const COOKIE_NAME_DOCEBO_ACCESS_TOKEN = 'docebo_access_token';

/** Stores the redirect target URL and platform context to redirect the user after checkout */
export const COOKIE_NAME_GLOBAL_REDIRECT_TARGET = 'global_redirect_target';
